module.exports = __webpack_public_path__ + "static/img/bg5.574f762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bg5.png
// module id = Kl+4
// module chunks = 1